module.exports = __webpack_public_path__ + "media/images/views/lp/client/risk/risk-pc-1bdfce172adba0ee8a60ef72f418aa7a.jpg";